import React from 'react';
import { motion } from 'framer-motion';
interface AuroraProps {
  className?: string;
  colorStops?: string[];
  intensity?: number;
}
export function Aurora({
  className = '',
  colorStops = ['#1a8fd4', '#0a4f7a', '#1a8fd4'],
  intensity = 0.4
}: AuroraProps) {
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-208">
      {/* Aurora blob 1 */}
      <motion.div className="absolute -top-1/4 -left-1/4 w-[75vw] h-[75vw] rounded-full blur-[120px]" style={{
      background: `radial-gradient(circle, ${colorStops[0]} 0%, transparent 70%)`,
      opacity: intensity
    }} animate={{
      x: ['0%', '20%', '-10%', '0%'],
      y: ['0%', '-15%', '10%', '0%'],
      scale: [1, 1.2, 0.9, 1]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-209" />

      {/* Aurora blob 2 */}
      <motion.div className="absolute -bottom-1/4 -right-1/4 w-[80vw] h-[80vw] rounded-full blur-[140px]" style={{
      background: `radial-gradient(circle, ${colorStops[1]} 0%, transparent 70%)`,
      opacity: intensity * 0.8
    }} animate={{
      x: ['0%', '-20%', '10%', '0%'],
      y: ['0%', '15%', '-10%', '0%'],
      scale: [1, 0.9, 1.2, 1]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-210" />

      {/* Aurora ribbon - top */}
      <motion.div className="absolute top-0 left-0 right-0 h-[40vh]" style={{
      background: `linear-gradient(180deg, ${colorStops[2]}40 0%, transparent 100%)`,
      filter: 'blur(60px)',
      opacity: intensity
    }} animate={{
      opacity: [intensity * 0.5, intensity, intensity * 0.5]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-211" />
    </div>;
}